export default class Grid {
  constructor(sizeName, width, height, lineWidth) {
    this._elWidth = document.querySelector(`.toolOptionGroup input[name="configGrid${sizeName}X"]`);
    this._elHeight = document.querySelector(`.toolOptionGroup input[name="configGrid${sizeName}Y"]`);
    this.width = width;
    this.height = height;
    this.lineWidth = lineWidth;
    this.strokeStyle = `#000000`;
    this.active = false;
  }
  set width(v) {
    const max = parseInt(this._elWidth.max);
    this._width = Math.max(0, Math.min(v, max));
  }
  set height(v) {
    const max = parseInt(this._elHeight.max);
    this._height = Math.max(0, Math.min(v, max));
  }
  get width() {
    return this._width;
  }
  get height() {
    return this._height;
  }
  draw(ctx, dragCamera, {width, height}) {
    if(!this.active) return;
    ctx.save();
    ctx.lineWidth = this.lineWidth;
    ctx.strokeStyle = this.strokeStyle;
    //ctx.globalAlpha = .75;

    //-- 縦線
    if(0 < this.width && 6 * this.lineWidth < dragCamera.worldSzToLocalSz(this.width)) {
      ctx.beginPath();
      const localY1 = dragCamera.worldYToLocalYD(0, false);
      const localY2 = dragCamera.worldYToLocalYD(height, false);
      for(let x = this.width; x < width; x += this.width) {
        const localX = dragCamera.worldXToLocalXD(x, this.lineWidth % 2 === 1);
        ctx.moveTo(localX, localY1);
        ctx.lineTo(localX, localY2);
      }
      ctx.stroke();
    }

    //-- 横線
    if(0 < this.height && 6 * this.lineWidth < dragCamera.worldSzToLocalSz(this.height)) {
      ctx.beginPath();
      const localX1 = dragCamera.worldXToLocalXD(0, false);
      const localX2 = dragCamera.worldXToLocalXD(width, false);
      for(let y = this.height; y < height; y += this.height) {
        const localY = dragCamera.worldYToLocalYD(y, this.lineWidth % 2 === 1);
        ctx.moveTo(localX1, localY);
        ctx.lineTo(localX2, localY);
      }
      ctx.stroke();
    }

    ctx.restore();
  }
  save() {
    return {
      width: this.width,
      height: this.height,
    };
  }
  restore({width, height}) {
    this.width = width;
    this.height = height;
    this._elWidth.value = this.width;
    this._elHeight.value = this.height;
  }
}
